export const ScreenSize = {
  XS: 'XS',
  SM: 'SM',
  MD: 'MD',
  LG: 'LG',
  XL: 'XL'
};

export const ScreenSizeEnum = {
  XS: 1,
  SM: 2,
  MD: 3,
  LG: 4,
  XL: 5
};

export const BreakpointMinWidth = {
  SM: 576,
  MD: 768,
  LG: 1030,
  XL: 1200
};

export function getScreenSize() {
  const w = window.innerWidth;
  if (w < BreakpointMinWidth.SM) {
    return ScreenSize.XS;
  }
  if (w < BreakpointMinWidth.MD) {
    return ScreenSize.SM;
  }
  if (w < BreakpointMinWidth.LG) {
    return ScreenSize.MD;
  }
  if (w < BreakpointMinWidth.XL) {
    return ScreenSize.LG;
  }

  return ScreenSize.XL;
}

export function getScreenSizeEnum() {
  const s = getScreenSize();
  return ScreenSizeEnum[s];
}

export function getScreenClassName() {
  return `screen-${getScreenSize().toLowerCase()}`;
}

export function isMobile() {
  return getScreenSizeEnum() < ScreenSizeEnum.LG;
  //return getScreenSizeEnum() < ScreenSizeEnum.MD;
}
export function isSmallScreen() {
  return getScreenSizeEnum() < ScreenSizeEnum.MD;
}
export function isTouchDevice() {
  return window.navigator.maxTouchPoints || 'ontouchstart' in document;
}

export function isXsScreen() {
  return getScreenSize() === ScreenSize.XS;
}

export function isLandscapeMode() {
  if (window.orientation === 90 || window.orientation === -90) return true;
  else return false;
}

export function isMobileDevice() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

const browserToolbarHeight = isLandscapeMode() ? screen.width - window.innerHeight : screen.height - window.innerHeight

export function getInnerWidth() {
 let innerWidth = isMobileDevice() ? (
    isLandscapeMode() ? window.screen.height : window.screen.width
  ) : window.innerWidth;
  if(innerWidth - window.innerWidth <= browserToolbarHeight )
  return window.innerWidth;
  else return innerWidth; 
}

export function getInnerHeight() {
 let innerHeight = isMobileDevice() ? (
    isLandscapeMode() ? window.screen.width : window.screen.height
  ) : window.innerHeight;
  if(innerHeight - window.innerHeight <= browserToolbarHeight )
  return window.innerHeight;
  else {
    innerHeight = innerHeight - browserToolbarHeight;
    return innerHeight
  }
}

export const HeightLeftWithoutHeaderInCalc = `calc(100vh - ${getHeaderHeight()}px)`;

export function getHeaderHeight() {
  if(BreakpointMinWidth.LG < getInnerWidth())
  return 70;
  else
  return 50;
}


